export const decodeChangelog = (changelogContents: string): [Date, string[]][] => {
    const releases = changelogContents.split("---").map(v => v.trim().split("\n"))

    const releasesByDate: Record<string, string[]> = {};

    releases.forEach(release => {
        if (release.length !== 2) { return }

        const desc = release[0];
        const listOfIds = release[1]?.split(" ");
        const date = desc?.split(" on ")[1].trim();

        if (!releasesByDate[date]) {
            releasesByDate[date] = listOfIds;
        } else {
            releasesByDate[date].push(...listOfIds)
        }
    });

    // convert this to array
    const releasesArray: [Date, string[]][] = [];
    Object.entries(releasesByDate).forEach(([date, ids]) => {
        ids.sort((a, b) => a.localeCompare(b));
        releasesArray.push([new Date(date), ids])
    });

    // sort by date, newest first
    releasesArray.sort((a, b) => b[0].getTime() - a[0].getTime())

    return releasesArray;
}
